import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, IdDescription, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { ProductAdditionalProductCost } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ProductAdditionalProductCostService extends TmsWebBaseEditCreateService<
  ProductAdditionalProductCost,
  ProductAdditionalProductCost
> {
  public refreshDetails = new Subject<void>();

  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('ProductAdditionalProductCost', $localize`Product Additional Product Cost`, httpService, notificationService);
  }

  getForProductSales(id: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForProductAdditionalProductCost/${id}`);
  }

  getAdditionalProductCostsForProduct(ProductId: string): Observable<ProductAdditionalProductCost[]> {
    return this.httpService.get<ProductAdditionalProductCost[]>(`${this.apiUrl}/Product/${ProductId}`);
  }

  getAllAdditionalProductCostsForProducts(ProductId: string): Observable<ProductAdditionalProductCost[]> {
    return this.httpService.get<ProductAdditionalProductCost[]>(
      `${this.apiUrl}/GetAllAdditionalProductCosts/${ProductId}`,
    );
  }

  updateAdditionalProductCostsProducts(ProductId: string, additionalProductCostIds: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateAdditionalProductCostsProducts`, {
      ProductId,
      additionalProductCostIds,
    });
  }
}
